  // 포맷터: 화면에 표시할 형식
  export const formatBusinessNumber = (value) => {
    if (!value) return "";
    const numericValue = value.replace(/\D/g, ""); // 숫자만 남기기
    const match = numericValue.match(/^(\d{0,3})(\d{0,2})(\d{0,5})$/);
    if (match) {
      return [match[1], match[2], match[3]].filter(Boolean).join("-");
    }
    return numericValue;
  };